import Image from "next/image";
import { Center } from "@chakra-ui/react";
import ConnectionGrahic from "public/internetAndDci/DCI_01.png";

const ConnectionGraphicImg = () => {
  return (
    <Center>
      <Image
        src={ConnectionGrahic}
        alt="Connection Graphic Image"
        style={{ height: "auto", maxWidth: "1200px", width: "100%" }}
      />
    </Center>
  );
};

export default ConnectionGraphicImg;
